import * as React from 'react';
import { flow, forEach, get } from 'lodash';
import { connect } from 'react-redux';
import { IStore } from '../../../../../../redux/IStore';
import { IMtaActions, IMtaFormNames, IMtaState } from '../../../../../../services/mta/models';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { mtaActions } from '../../../../../../services/mta/actions';
import { withRouter } from 'react-router';
import { formValueSelector, reduxForm } from 'redux-form';
import Heap from '../../../../../../helpers/Heap';
import { IAuthState } from '../../../../../../services/auth/models';
import { paymentMethodActions } from '../../../../../../services/paymentMethod/actions';
import { IPaymentMethodActions } from '../../../../../../services/paymentMethod/models';
import { OPTION_MAPPING } from '../../../../../../services/branding/models';
import { InfoAnnie } from '../../../../../../components/InfoAnnie';
import { MTAButtons } from '../MTAButtons';
import { Button } from 'react-bootstrap';
import { MTACardHeader } from '../CoverDetails/scenes/Components/MTACardHeader';

interface IMakeAChangeCompleteProps {
  auth: IAuthState;
  mta: IMtaState;
  dispatch: any;
  history: any;
  isUpsell: boolean;
  removeOption: string[];
  premium: any;
  actions: {
    paymentMethod: IPaymentMethodActions;
    mta: IMtaActions;
  };
}

class MakeAChangeComplete extends React.Component<IMakeAChangeCompleteProps, any> {

  constructor(props) {
    super(props);
    const { actions } = props;

    this.initTracking();
    actions.mta.setCompleteMTA();
    window.scrollTo(0, 0);
  }

  private initTracking = () => {
    const { actions, mta, auth } = this.props;
    const selectedScheme = actions.mta.getSelectedScheme();

    const premium = get(selectedScheme, 'premium.gross', 0);
    let premiumType = 'ZP'

    if (premium > 0) {
      premiumType = 'AP'
    }

    if (premium < 0) {
      premiumType = 'RP'
    }

    Heap.trackActivePolicyEvent(
      'MtaCompletePage',
      mta.selectedPolicy,
      get(auth, 'customer.marketingOptions'),
      actions.paymentMethod.getPolicyPaymentMethod(get(mta.selectedPolicy, 'assignedPaymentMethods')),
      premiumType
    );
  }

  private renderReturnToPolicyLink = () => {
    const { mta } = this.props;
    const policyId = mta.afterSubmit.policyId;

    const link = (
      <div>
        <Link to={`/account/policies/${policyId}`}>
          <Button
            id="back"
            bsStyle="primary"
            className="pull-left secondary-button"
          >RETURN TO YOUR POLICY</Button>
        </Link>
      </div>
    );

    return (
      <>
        <div className={'mt-15'}/>
        <MTAButtons button1={link}/>
      </>
    )
  }

  private renderRemoveOptionContent = () => {
    const { premium, removeOption } = this.props;
    const returnPremium = Math.abs(premium).toFixed(2)
    const isZeroPremium = returnPremium === '0.00';
    const selectedForRemoval = [];


    forEach(removeOption, (option) => {
      if (get(OPTION_MAPPING, option)) {
        selectedForRemoval.push(get(OPTION_MAPPING, option))
      }
    })

    const optionsToDisplay = selectedForRemoval.join(', ');

    return (
      <div className={'mt-30'}>
        <MTACardHeader text={'Additional cover removed'} icon={'thumbs-up'}/>
        <div className={'white-card'}>
          <p>
            {isZeroPremium && (
              <>{optionsToDisplay} {selectedForRemoval.length > 1 ? 'have' : 'has'} been removed from your policy. As
                cover has been removed after the 14-day policy
                cooling off period, there is no refund.</>
            )}
            {!isZeroPremium && (
              <>{optionsToDisplay} {selectedForRemoval.length > 1 ? 'have' : 'has'} been removed from your policy. You
                will receive a refund of
                £{returnPremium} which will be returned to the card on file within 3-10 working days.</>
            )}
          </p>
          <p className="mb-25">
            We have made the change requested and you will receive an email containing a link where you can view and
            download your documents online. You must check that the cover and your details are correct; if they are not,
            please let us know as incorrect details could invalidate your cover and affect any future claims.
          </p>
        </div>
        {this.renderReturnToPolicyLink()}
      </div>
    )
  }

  private renderCompleteSuccessBanner = (text: string, isUpsell: boolean = false) => {
    const { auth } = this.props;
    const customerFirstName = auth?.customer?.firstName;

    return (
      <div>
        <InfoAnnie title={`Thank you, ${customerFirstName}`} text={text} color={'green'}/>
        {isUpsell && (
          <p style={{ margin: '25px 0 25px 0' }}>
            Please remember, if your trip will include winter Sports activities or a cruise, you must add the relevant
            covers or you will not be covered by this policy. You can add these covers by clicking ‘make a change’ at
            the top of the page.
          </p>
        )}
        {this.renderReturnToPolicyLink()}
      </div>
    )
  }

  private renderSuccessContent = () => {
    const { isUpsell, removeOption, mta, premium } = this.props;
    const isZeroPayment = mta?.afterSubmit?.isZeroPayment || false;
    const chargedPremium = mta?.afterSubmit?.grossPremium ? parseFloat(mta?.afterSubmit?.grossPremium).toFixed(2) : null;
    let text = `We\'ve received payment for £${chargedPremium} and will send a confirmation email within 24 hours.`
    let returnPremium = null;

    if (premium && premium < 0) {
      returnPremium = Math.abs(premium).toFixed(2)
    }

    if (removeOption && removeOption.length > 0) {
      return this.renderRemoveOptionContent()
    }

    if (returnPremium) {
      text = `You will receive a refund of £${returnPremium} which will be returned to the card on file within 3-10 working days.`
      return (
        <>
          {this.renderCompleteSuccessBanner(text)}
        </>
      )
    }

    if (isZeroPayment && !isUpsell || !chargedPremium) {
      text = 'Your changes have been made and your new policy documents are available to view.'
      return (
        <>
          {this.renderCompleteSuccessBanner(text)}
        </>
      )
    }

    return (
      <>
        {this.renderCompleteSuccessBanner(text, isUpsell)}
      </>
    );
  }

  private renderFailedContent = () => {
    return (
      <div className={'mt-30'}>
        <MTACardHeader text={'Make a Change - There has been a problem'}/>
        <div className={'white-card'}>
          <p className="mb-25">
            Unfortunately there has been a problem with updating your details, please see
            our <a className="pointer" href={'https://www.admiral.com/contact-us/travel'} target={'_blank'}>Contact
            Us</a> page for
            details on how to get in touch.
          </p>
        </div>
      </div>
    );
  }

  private renderNoChangesContent = () => {
    const policyId = this.props.mta.afterSubmit.policyId;
    return (
      <div className={'mt-30'}>
        <MTACardHeader text={'Make a Change - Confirmation'}/>
        <div className={'white-card'}>
          <p className="mb-25">
            There has been no change to your personal details on this policy, please go back and make a change.
          </p>
        </div>
        <div className="return-to-account-btn mt-15">
          <Link to={`/account/make-a-change/personal-details/${policyId}`}>
            GO BACK
          </Link>
        </div>
      </div>
    );
  }

  public render() {
    const { mta } = this.props;
    if (mta.afterSubmit.success && mta.afterSubmit.changes !== 0) {
      return this.renderSuccessContent();
    } else if (mta.afterSubmit.changes === 0) {
      return this.renderNoChangesContent();
    } else {
      return this.renderFailedContent();
    }
  }
}

let selector;

export default flow([
  withRouter,
  reduxForm({
    form: IMtaFormNames.COVER_DETAILS,
    destroyOnUnmount: true,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector(IMtaFormNames.COVER_DETAILS);
    return component;
  },
  connect(
    (state: IStore) => ({
      auth: state.auth,
      mta: state.mta,
      isUpsell: selector(state, 'isUpsell'),
      removeOption: selector(state, 'removeOption'),
      premium: selector(state, 'premium')
    }),
    (dispatch) => ({
      actions: {
        mta: bindActionCreators({ ...mtaActions }, dispatch),
        paymentMethod: bindActionCreators({ ...paymentMethodActions }, dispatch),
      },
    }),
  ),
])(MakeAChangeComplete);
